// extracted by mini-css-extract-plugin
export default {"message":"message_message__28eE6","message1":"message_message1__OaSWk","message2":"message_message2__8R8hN","message3":"message_message3__XaQUa","message4":"message_message4__EeLxM"};